import CueUpsert from "./cue_upsert";
import { useEffect, useState } from "react";
import metaDataServices from "../MetaDataServices";
import CustomFilter from "../Custom_Filter";
import CueSongUpsert from "./cueSong_upsert";
import AddCueSongUpsert from "./AddCueSongUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";

export default function Cue(subEntity: any) {

    let [cuelist, Setcuelist] = useState<any>([]);
    let [cueOpen, SetcueOpen] = useState(false);
    var payLoad = { pageNumber: 1, pageSize: 10 }
    let [cuelistCount, SetcuelistCount] = useState(0);
    let [deleteRow, SetDeleteRow] = useState<any>([]);
    let [cueUpsert, SetcuelUpsert] = useState<any>([]);
    let [AddSongToCue, SetAddSongToCue] = useState(false);
    let [cueSelected, SetCueSelected] = useState<any>([]);
    let [deleteConfirm, SetDeleteConfirm] = useState(false);
    let [CustomFilterOpen, SetCustomFilterOpen] = useState(false);

    useEffect(() => {
        apiCall();

    }, [subEntity])

    const apiCall = () => {

        metaDataServices.cuelistSearch(payLoad).then((res: any) => {
            cuelist = res
            Setcuelist(cuelist);
            cuelistCount = res[0]?.totalRows ?? 0
            SetcuelistCount(cuelistCount)

        })
    }

    const onChangecueUpsert = (e: any) => {

        console.log(e)
        cueOpen = false;
        SetcueOpen(cueOpen)
        apiCall();
    }

    const openCueEdit = (e: any) => {
        cueUpsert = e;
        SetcuelUpsert(e)

        cueOpen = true;
        SetcueOpen(cueOpen)
    }

    const onChangeCustomFilter = (e: any) => {
        CustomFilterOpen = false;
        SetCustomFilterOpen(CustomFilterOpen)
    }

    const SelectAddSongToCue = (e: any) => {
        AddSongToCue = true;
        SetAddSongToCue(AddSongToCue);

        cueSelected = e;
        SetCueSelected(cueSelected)

    }

    const onChangeAddSongToCue = (e: any) => {
        AddSongToCue = false;
        SetAddSongToCue(AddSongToCue)
        apiCall();
    }

    const report801 = (e: any) => {

        console.log(e)
        if (e) {

            var url = "/Api/CrystalReport/CrystalReport801.aspx?template=Reports/Crystal801.rpt&format=pdf&productionId=" + e.productionId + '&programNumber=' + e.programNumber + '&masterCue=' + e.masterCue;
            window.open(url);
        }
    }

    const deleteConfirmation = (e: any) => {
        console.log(e)
        console.log(deleteRow)
        if (e == 1) {
            metaDataServices.cueDelete(deleteRow.cueId).then((res: any) => {
                apiCall();
            })
        }

        deleteConfirm = false;
        SetDeleteConfirm(deleteConfirm)
    }

    let [searchFor, SetSearch] = useState("");
    let [activitySelection, SetactivitySelection] = useState("");
    let [statusSelection, SetStatusSelection] = useState("");
    let [updatedSelection, SetupdatedSelection] = useState("");

    const clearFilter = () => {
        searchFor = '';
        SetSearch(searchFor)

        activitySelection = '';
        SetactivitySelection(activitySelection)

        statusSelection = '';
        SetStatusSelection(statusSelection)

        updatedSelection = '';
        SetupdatedSelection(updatedSelection)
    }

    return (<>

        <div className="ws-12 ps">
            <div className="ws-12 box pm hide">

                <div className="ws-12 ">
                    <div className="ws-4 pm">
                        <label className="ws-12 text-bold">Master Cue</label>
                        <input type="text" id="masterCue" name="masterCue" className="ws-10" placeholder="Master Cue" />
                    </div>

                    <div className="ws-4 pm">
                        <label className="ws-12 text-bold">Cue Theme</label>
                        <input type="text" id="cueTheme" name="cueTheme" className="ws-10" placeholder="Cue Theme" />
                    </div>

                    <div className="ws-4 pm">
                        <label className="ws-12 text-bold">Cue Sheet Type</label>
                        <select id="cueSheetType" name="cueSheetType" className="ws-10">
                            <option value="">Choose cue sheet type</option>
                            {global?.cueSheetType?.map((values: any) => {
                                return (<option className="width200">{values?.cueSheetTypeDesc}</option>)
                            })}
                        </select>
                    </div>

                    <div className="ws-4 pm">
                        <label className="ws-12 text-bold">Cue Status</label>
                        <select id="cueStatus" name="cueStatus" className="ws-10">
                            <option value="">Choose Status</option>
                            {global?.statusProduct?.map((values: any) => {
                                return (<option className="width200">{values.ProductStatusShortCode}</option>)
                            })}
                        </select>
                    </div>

                    <div className="ws-4 pm">
                        <label className="ws-12 text-bold">Program Number</label>
                        <input type="text" id="programNumber" name="programNumber" className="ws-10" placeholder="Program Number" />
                    </div>

                    <div className="ws-4 pm">
                        <label className="ws-12 text-bold">Extended Status</label>
                        <select id="extendedStatus" name="extendedStatus" className="ws-10">
                            <option value="">Choose Status</option>
                            {global?.statusProductExt?.map((values: any) => {
                                return (<option className="width200">{values.productStatusExtName}</option>)
                            })}
                        </select>
                    </div>

                    <div className="ws-4 pm">
                        <label className="ws-12 text-bold">Production Id</label>
                        <input type="text" id="productionId" name="productionId" className="ws-10" placeholder="Production Id" />
                    </div>

                    <div className="ws-4" aria-hidden="true"></div>
                </div>

                <div className="ws-12 mtl">
                    <button type="button" className="icon-btn edit" id="newCueBtn" onClick={() => openCueEdit({})}>New Cue</button>
                    <button type="submit" className="icon-btn edit pull-right" id="searchBtn">Search</button>
                    <button type="reset" className="btn icon-btn delete pull-right mr1" id="resetBtn">Reset</button>
                </div>

            </div>

            <div className='ws-12 box mbl'>
                <div className='ws-12 pm'>

                    <div className='w-75'>
                        <div className='ws-6 box ps height40'>
                            <input type="text" className="ws-12 pull-right height30" value={searchFor} onChange={(e) => SetSearch(e.target.value)}
                                placeholder='Search by Master Cue, Cue Theme' style={{ border: 'none', outline: 'none' }} />
                        </div>

                        <select className='pm pbl height40 grey text-bold icon-btn info' value={statusSelection} onChange={(e: any) => SetStatusSelection(e.target.value)}>
                            <option value={'All'}> All</option>
                            <option value={'BECS Member'}> Cue Member</option>
                        </select>

                        <button className='pm pbl height40 width90 white text-bold icon-btn info' onClick={() => SetCustomFilterOpen(true)}>
                            Filter
                        </button>
                    </div>

                    {(searchFor.length > 0 || statusSelection.length > 0 || activitySelection.length > 0 || updatedSelection.length > 0) &&
                        <button type="button" className="text-bold icon-btn delete height40 mr pull-left width70" onClick={clearFilter}>Clear</button>}
                    <button type="button" className="text-bold icon-btn edit pull-right height40" onClick={() => openCueEdit({})}>New Cue</button>
                    <button type="button" className="text-bold icon-btn info pull-right height40" >Export</button>
                </div>
            </div>

            {(searchFor.length > 0 || statusSelection.length > 0 || activitySelection.length > 0 || updatedSelection.length > 0) && <div className='ws-12 pm'>

                <div className='ws-12 box landing pm text-center'>
                    {searchFor.length > 0 && <>
                        <span className='text-bold mr'>Search : </span>
                        <span className='mr'>{searchFor} </span>
                    </>}

                    {statusSelection.length > 0 && <>
                        <span className='text-bold mr'>Status :</span>
                        <span className='mr'>{statusSelection}</span>
                    </>}

                    {activitySelection.length > 0 && <>
                        <span className='text-bold mr'>Activity :</span>
                        <span className='mr'>{activitySelection}</span>
                    </>}
                    {updatedSelection.length > 0 && <>
                        <span className='text-bold mr'>Updated :</span>
                        <span className='mr'>{updatedSelection}</span>
                    </>}
                </div>

            </div>}

            <div className="ws-12">

                <table className="newTable mtl">
                    <thead>
                        <tr>
                            <th >Master Cue</th>
                            <th >Cue SheetType</th>
                            <th >Production Id</th>
                            <th >Program Number</th>
                            <th >Cue Theme</th>
                            <th >Cue Status</th>
                            <th >Extended Status</th>
                            <th >Runtime</th>
                            <th >Total Songs</th>
                            <th style={{ width: "14%" }}>Operations</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cuelist.map((row: any) => (
                            <tr>
                                <td>{row.masterCue}</td>
                                <td>{row.cueSheetType}</td>
                                <td>{row.productionId}</td>
                                <td>{row.programNumber}</td>
                                <td>{row.cueTheme}</td>
                                <td>{row.productStatusName}</td>
                                <td>{row.productStatusExtName}</td>
                                <td>  {String(row.runtimeDurationMinute).padStart(2, '0')} : {String(row.runtimeDurationSecond).padStart(2, '0')} </td>
                                <td className="text-right">
                                    <span className="ptl ws-4"> {row.totalSongs} </span>
                                    <button className="icon-btn edit pull-right" title="Add Songs to Cue" type="button" onClick={() => SelectAddSongToCue(row)}>
                                        <i className="icon-plus"> </i>
                                    </button>
                                </td>
                                <td>

                                    <button className="icon-btn edit" title="Edit" type="button" onClick={() => openCueEdit(row)}>
                                        <i className="icon-pencil"> </i>
                                    </button>

                                    <button className="icon-btn delete" title="Delete" type="button" onClick={() => { SetDeleteConfirm(true); SetDeleteRow(row) }}>
                                        <i className="icon-trash"> </i>
                                    </button>

                                    <button className="icon-btn info" title="Report 801" type="button" onClick={() => report801(row)}>
                                        <i className="icon-file"> </i>
                                    </button>

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {
                (() => {

                    if (cueOpen) {
                        return <CueUpsert onChange={onChangecueUpsert} cueUpsert={cueUpsert} cueOpen={cueOpen} />
                    }

                    if (CustomFilterOpen) {
                        return <CustomFilter onChange={onChangeCustomFilter} CustomFilterOpen={CustomFilterOpen} type="CueListing" />
                    }

                    if (AddSongToCue) {
                        return <AddCueSongUpsert onChangeAddSongToCue={onChangeAddSongToCue} AddSongToCue={AddSongToCue} cueSelected={cueSelected} />
                    }

                    if (deleteConfirm) {
                        return <DeleteDialogueBox param={true} message={"to remove this cue"} onChange={deleteConfirmation} />
                    }

                })()
            }

        </div>

    </>)
}